<div class="collapsable-container"
[ngStyle]="{
        'margin-top': '25px',
        'border-left': '4px solid #1976d2',
        'background': '#eef6ff'
     }"
>
    <div class="collapsable-container-header" (click)="toggleCollapse()">
        <span class="btn-collapse" (click)="toggleCollapse()"><span class="fa fa-fw fa-angle-double-down"></span></span>
        <div class="heading">{{ 'EPRIJEMNICASTAVKA.DODATNIATRIBUTI.TITLE' | translate }}</div>
    </div>
    <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
        <yt-eprijemnica-stavka-dodatni-atribut-update
            #baseUpdate
        >
        </yt-eprijemnica-stavka-dodatni-atribut-update>
        <!-- <yt-eprijemnica-stavka-dodatni-atribut-inline-update
            #baseUpdate
            [NestedInline]="true"
            [Level]="2"
        ></yt-eprijemnica-stavka-dodatni-atribut-inline-update>         -->
        <!-- <div class="row">
            <div class="col-md-12">
                <div class="btn-group float-right">
                    <button type="button" class="btn btn-outline-primary" (click)="Save()" [disabled]="saveDisabled"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
                    <button type="button" class="btn btn-outline-primary" (click)="Reset()"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                </div>
            </div>
        </div> -->
    </div>
</div>